import React from "react";
import { Icon } from "@ebscois/react-component-library";
import { Fragment } from "react";

const CommonComponents = () => {
  return (
    <Fragment>
      <Icon
        emitSymbol
        icon={{
          glyph: "launch",
          color: "link",
          hideForPrint: true,
          size: "xs",
        }}
        id="external-launch"
      />
      <Icon
        emitSymbol
        icon={{
          color: "link",
          glyph: "picture_as_pdf",
          hideForPrint: true,
          size: "xs",
        }}
        id="external-pdf"
      />
      <Icon
        emitSymbol
        icon={{
          glyph: "table_chart",
          color: "link",
          hideForPrint: true,
          size: "xs",
        }}
        id="table-modal-icon"
      />
      <Icon
        emitSymbol
        icon={{
          glyph: "info",
          color: "gray600",
          size: "md",
        }}
        id="commentary-icon"
      />
    </Fragment>
  );
};

CommonComponents.componentName = "Common Components";

export default CommonComponents;
